document.addEventListener('DOMContentLoaded', new Swiper(".myswiper", {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 5, 
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: false,
  },
  touchStartPreventDefault: false,
}));

// 

/* new Swiper(".myswiper", {
  slidesPerView: 1,
  loop: !0,
  spaceBetween: 5,
  autoplay: { delay: 9e3, disableOnInteraction: !1 },
  navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
}); */



document.querySelectorAll(".myswiper").forEach((swiperEl) => {
    new Swiper(swiperEl, {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 5,
      autoplay: false
    });
  });




var swiper = new Swiper(".responsive-carousel", {
        loop: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView:1,
        paginationClickable: true,
        spaceBetween: 10,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },   
        breakpoints: {
            1920: {
                slidesPerView: 4,
                spaceBetween: 15
            },
            1028: {
                slidesPerView: 4,
                spaceBetween: 15
            },
            480: {
                slidesPerView: 3,
                spaceBetween: 10
            }
          ,
            320: {
                slidesPerView: 1.8,
                spaceBetween: 10
            }
        }
    });
    
    

    // Home page slider
        var swiper = new Swiper(".homebannerslider", {
      pagination: {
        el: ".swiper-pagination",
            clickable: true,
      },
        loop: true,
        autoplay: {
            delay: 3000,
            pauseOnMouseEnter: true,
        }
    });
    
function adjustHomeBannerSliderOffset() {
  const isHomepage = document.body.classList.contains('index');
  if (!isHomepage) return;

  const banner = document.querySelector('.homebannerslider');
  if (!banner) return;

  if (!window.matchMedia('(min-width: 769px)').matches) {
    banner.style.marginTop = '';
    return;
  }

  const headerGroup = document.querySelector('.shopify-section-group-header-group');
  if (!headerGroup) return;

  const height = headerGroup.getBoundingClientRect().height;
  banner.style.marginTop = `-${Math.round(height)}px`;
}

if (document.readyState !== 'loading') {
  adjustHomeBannerSliderOffset();
} else {
  document.addEventListener('DOMContentLoaded', adjustHomeBannerSliderOffset);
}

window.addEventListener('resize', adjustHomeBannerSliderOffset);


